import { Component, Host, h, Prop, State, Element } from '@stencil/core';

@Component({
  tag: 'salla-installment',
  styleUrl: 'salla-installment.scss',
})
export class SallaInstallment {
  private tabbyBorderRemoved: boolean = false;
  private tabbyRemoveBorderTries: number = 0;
  @Element() host: HTMLElement;
  constructor() {
    salla.lang.onLoaded(() => {
      const installmentOptions = [
        { key: 'pages.products.installments', installments: 3 },
        { key: 'pages.products.installments_emkan', installments: 5 },
      ];

      installmentOptions.forEach(option => {
        this.installment_sheria_text(option.key, {
          payment: salla.money(parseFloat(this.price)),
          amount: salla.money((parseFloat(this.price) / option.installments).toFixed(2)).replace(/\.00$/, ''),
          installments: option.installments,
        });
      });

      const installment = salla.config.get('store.settings.installments');
      if (installment) {
        this.tamaraIsActive = installment.tamara;
        this.tabbyIsActive = installment.tabby;
        this.spotiiIsActive = installment.spotii;
        this.mispayActive = installment.mispay;
        this.emkanIsActive = installment.emkan;
        this.madfuActive = installment.madfu;
        this.rajehiIsActive = installment.mokafaa_alrajhi
      }
      this.renderInstallments();
    });

    salla.event.on('product::price.updated', ({ data }) => {
      if (!data.price || data.price == this.price) {
        return;
      }
      this.price = data.price;
      this.renderInstallments(true);
    });
  }

  /**
   * Current product price
   */
  @Prop() price: string;
  /**
   * Language code
   */
  @Prop() language: string = salla.config.get('user.language_code');
  /**
   * Currency code
   */
  @Prop() currency: string = salla.config.get('user.currency_code');
  /**
   * Country code
   */
  @Prop() country: string = salla.config.get('user.country_code');

  @State() tabbyIsActive: boolean;
  @State() spotiiIsActive: boolean;
  @State() tamaraIsActive: null | { publicKey: string };
  @State() mispayActive: null | { merchantCode: string; publicKey: string };
  @State() emkanIsActive: boolean;
  @State() madfuActive: boolean;
  @State() rajehiIsActive?: { pointsPerRiyal: number };

  @State() installment_sheria_text: (key: string, replacement: object) => string = (key, replacement) => salla.lang.get(key, replacement);


  render() {
    const isSAR = this.currency === 'SAR';

    if (!this.isValidPrice(this.price)) {
      return '';
    }
    return (
      <Host>
        {this.tamaraIsActive &&
          (this.tamaraIsActive?.publicKey ? (
            // Tamara widget v2
            <div class="mb-5">
              <tamara-widget
                type="tamara-summary"
                inline-type="2"
                amount={this.price}
              ></tamara-widget>
            </div>
          ) : (
            // Tamara widget v1 fallback
            <div
              class="tamara-product-widget"
              data-price={this.price}
              data-currency={this.currency}
              data-lang={this.language}
              data-payment-type="installment"
            ></div>
          ))}

        {this.tabbyIsActive ? (
          <div id="tabbyPromoWrapper">
            <div id="tabbyPromo"></div>
          </div>
        ) : (
          ''
        )}

        {this.spotiiIsActive ? (
          <div class="spotii-wrapper">
            {/*No need for the price, the price already in the page, and also tammara & tabby doesn't have price */}
            <div class="spotii-promo"></div>
          </div>
        ) : (
          ''
        )}

        {this.shouldShowMispay() &&
          (this.mispayActive.publicKey ? (
            <div class="mb-5">
              <mispay-widget amount={this.price} lang={this.language}></mispay-widget>
            </div>
          ) : (
            <div class="s-installment-mispay-wrapper">
              <div class="s-installment-mispay-content">
                <img src={salla.url.cdn('images/payment/png/mispay.png')} alt="mispay" />
                <span class="s-installment-mispay-content-text" innerHTML={this.installment_sheria_text('pages.products.installments',{
                    payment: salla.money(parseFloat(this.price)),
                    amount: salla.money((parseFloat(this.price) / 4).toFixed(2)),
                    installments: 4,
                  })}></span>
              </div>
            </div>
          ))}

        {this.emkanIsActive && this.currency === "SAR" ? (
           <div class="s-installment-emkan-wrapper">
           <div class="s-installment-emkan-content">
             <img src={salla.url.cdn('images/payment/png/emkan.png')} alt="emkan" />
             <span class="s-installment-emkan-content-text" innerHTML={this.installment_sheria_text('pages.products.installments_emkan', {
                 payment: salla.money(parseFloat(this.price)),
                 amount: salla.money((parseFloat(this.price) / 5).toFixed(2)),
                 installments: 5,
               })}></span>
           </div>
         </div>
        ) : (
          ''
        )}
        {this.madfuActive && this.currency === "SAR" ? (
          <div class="s-installment-madfu-wrapper">
            <div class="s-installment-madfu-content">
              <img
                src={
                  salla.url.cdn('images/payment/png/madfu.png')
                }
                alt="madfu"
              />
              <span class="s-installment-madfu-content-text">
                {salla.lang.get('pages.products.installments_madfu')}
              </span>
            </div>
          </div>
          ) : (
            ''
        )}

        {(isSAR && this.rajehiIsActive) ?
          <div class="s-installment-rajehi-wrapper">
            <div class="s-installment-rajehi-content">
              <img src={salla.url.cdn('images/payment/png/mokafaa_alrajhi_loyalty.png')} alt="mokafaa_alrajhi_loyalty"/>

              <span class="s-installment-rajehi-content-text">
                {salla.lang.get("pages.products.rajahi_earn_points", {points: Math.floor(+this.price * this.rajehiIsActive.pointsPerRiyal)})}
              </span>

            </div>
          </div>

          : ''}
      </Host>
    );
  }

  renderInstallments(isUpdating: boolean = false) {
    if (!this.isValidPrice(this.price)) {
      return;
    }
    // Tamara
    if (this.tamaraIsActive) {
      this.loadTamara({isUpdating});
    }

    // tabby
    if (this.tabbyIsActive) {
      if (isUpdating) {
        // remove #tabbyPromoWrapper and re append it
        var oldTabbyWrapper = this.host.querySelector('#tabbyPromoWrapper');
        if (oldTabbyWrapper) {
          oldTabbyWrapper.remove();
        }

        var tabbyPromoWrapper = document.createElement('div');
        tabbyPromoWrapper.setAttribute('id', 'tabbyPromoWrapper');
        var tabbyPromo = document.createElement('div');
        tabbyPromo.setAttribute('id', 'tabbyPromo');
        tabbyPromoWrapper.appendChild(tabbyPromo);
        this.host.appendChild(tabbyPromoWrapper);

        var oldTabbyScript = document.querySelector(
          'script[src="https://checkout.tabby.ai/tabby-promo.js"]',
        );
        if (oldTabbyScript) {
          oldTabbyScript.remove();
        }
      }

      var tabbyScript = document.createElement('script');
      tabbyScript.setAttribute('src', 'https://checkout.tabby.ai/tabby-promo.js');
      document.head.appendChild(tabbyScript);
      tabbyScript.onload = () => {
        const TabbyPromo = window.TabbyPromo;
        new TabbyPromo({
          selector: '#tabbyPromo',
          currency: this.currency,
          price: this.price,
          lang: this.language,
          publicKey: salla.config.get('store.settings.installments.tabby.publicKey'),
          merchantCode: salla.config.get('store.settings.installments.tabby.merchantCode'),
        });
        document.querySelectorAll('.tabby-promo-snippet__logo').forEach(function (element) {
          element.setAttribute('aria-label', 'Tabby Logo');
        });
      };
      // this is a workaround to remove the default border and add margin
      this.removeTabbyBorder();
    }

    // Spotii
    if (this.spotiiIsActive) {
      if (isUpdating) {
        var oldSpotiiWrapper = this.host.querySelector('.spotii-wrapper');
        if (oldSpotiiWrapper) {
          oldSpotiiWrapper.remove();
        }

        var spotiiPromoWrapper = document.createElement('div');
        spotiiPromoWrapper.classList.add('spotii-wrapper');
        var spotiiPromo = document.createElement('div');
        spotiiPromo.classList.add('spotii-promo');
        spotiiPromoWrapper.appendChild(spotiiPromo);
        this.host.appendChild(spotiiPromoWrapper);
        var oldSpotiiScript = document.querySelector(
          'script[src="' + salla.url.cdn('js/price-widget-ar-salla.js') + '"]',
        );
        if (oldSpotiiScript) {
          oldSpotiiScript.remove();
        }
      }

      let amount = salla.money((Number(this.price) / 3).toFixed(2), false);
      let isRTL = salla.config.get('theme.is_rtl', true);
      window.spotiiConfig = {
        targetXPath: ['.spotii-wrapper'],
        renderToPath: ['.spotii-promo'],
        numberOfPayment: 3,
        currency: this.currency,
        templateLine: '${textOne} ${number} ${textTwo} ' + amount + '${logo} ${info}',
        //todo:: translate these
        textOne: isRTL ? 'جزء الدفع على' : 'Split it into',
        textTwo: isRTL ? 'أقساط متساوية بدون تكاليف اضافية بقيمة' : 'payments of',
        textThree: 'مع',
        price: this.price,
        // forcedShow: false,
        // merchantID: null,
      };

      var spotiiScript = document.createElement('script');
      spotiiScript.setAttribute('src', salla.url.cdn('js/price-widget-ar-salla.js'));
      document.head.appendChild(spotiiScript);
      // spotiiScript.onload = () => {
      //   // setTimeout()
      // }
    }

    // Mispay
    if (this.shouldShowMispay() && this.mispayActive.publicKey) {
      this.loadExternalScript({
        position: 'head',
        src: `https://widget.mispay.co/v1/sdk.js?authorize=${this.mispayActive.publicKey}`,
      });
    }
  }

  private isValidPrice(price: string): boolean {
    const pricePattern = /^\d+(\.\d{1,2})?$/;
    const isValid = pricePattern.test(price);
    const isGreaterThanZero = parseFloat(price) > 0;

    return isValid && isGreaterThanZero;
  }

  loadExternalScript({
    src,
    onLoad,
    position,
  }: {
    src: string;
    onLoad?: HTMLScriptElement['onload'];
    position: 'head' | 'body';
  }) {
    const script = document.createElement('script');
    script.src = src;
    script.onload = onLoad;
    document[position].appendChild(script);
  }

  loadTamara({ isUpdating }: { isUpdating: boolean }) {
    const isV2Enabled = !!this.tamaraIsActive?.publicKey;

    if (isUpdating) {
      setTimeout(() => {
        if (isV2Enabled) {
          return window.TamaraWidgetV2?.refresh();
        }

        // v1 fallback widget refresh
        window.TamaraProductWidget?.render();
      }, 300);
    } else {
      if (isV2Enabled) {
        const language_code = salla.config.get('user.language_code');
        const lang = ['ar', 'en'].includes(language_code) ? language_code : 'ar';
        // this used in case user change the currency to get the country code
        const countryCodeByCurrency = this.currency?.slice(0, -1);

        const country = ['SA', 'AE', 'KW', 'BH', 'OM', 'QA'].includes(countryCodeByCurrency)
          ? countryCodeByCurrency
          : null;

        if (!country) {
          console.error('Tamara: Country code is not supported', countryCodeByCurrency);
        } else {
          window.tamaraWidgetConfig = {
            lang,
            country,
            publicKey: this.tamaraIsActive.publicKey,
            style: {
              fontSize: '14px',
            },
          };

          this.loadExternalScript({
            position: 'head',
            src: 'https://cdn.tamara.co/widget-v2/tamara-widget.js',
          });
        }
      } else {
        // v1 fallback widget
        this.loadExternalScript({
          position: 'head',
          src: 'https://cdn.tamara.co/widget/product-widget.min.js',
          onLoad: () => {
            window.TamaraProductWidget.init({ lang: this.language });
            setTimeout(() => {
              window.TamaraProductWidget.render();
            }, 300);
          },
        });
      }
    }
  }

  shouldShowMispay() {
    return this.currency === 'SAR' && this.mispayActive && parseInt(this.price) >= 200;
  }

  /**
   * this is workaround to remove the default border and add margin
   * we will try to remove tabby border 5 times for 7.5 seconds
   */
  removeTabbyBorder() {
    if (this.tabbyBorderRemoved || this.tabbyRemoveBorderTries > 5) {
      return;
    }
    this.tabbyRemoveBorderTries++;
    setTimeout(() => {
      let promo: any = document.querySelector('#tabbyPromo>div>div');
      promo = promo
        ? promo.shadowRoot.querySelector('div[class^="styles__tabby-promo-snippet--"]')
        : null;
      if (promo) {
        promo.style = 'border: none; margin: 15px 0!important;';
        this.tabbyBorderRemoved = true;
      } else {
        this.removeTabbyBorder();
      }
    }, this.tabbyRemoveBorderTries * 500);
  }
}
